const DEFAULT_COUNTRY = 'Denmark';
/**
 * Efkt's field names differ from booqly's model on three of eight: `floorNumber`→`floor`,
 * `apartmentNumber`→`appartmentNumber`, `postalCode`→`postNumber`. `area` has no Efkt source.
 *
 * The pre-Efkt tree open-codes this rename in five places; keep it in exactly one here.
 */
export function mapAddressFromDto(dto) {
    return {
        full: dto.addressFull || [dto.street, dto.houseNumber].filter(Boolean).join(' '),
        street: dto.street,
        houseNumber: dto.houseNumber || '',
        floor: dto.floorNumber,
        appartmentNumber: dto.apartmentNumber,
        postNumber: dto.postalCode,
        city: dto.city,
        country: dto.country,
    };
}
export function mapAddressToDto(address) {
    return {
        street: address.street,
        houseNumber: address.houseNumber || undefined,
        floorNumber: address.floor,
        apartmentNumber: address.appartmentNumber,
        city: address.city,
        postalCode: address.postNumber,
        // booqly resolves addresses through DAWA/Google and keeps no country on the model, so fall
        // back rather than send an empty string — the backend's completeness guard rejects blanks.
        country: address.country || DEFAULT_COUNTRY,
    };
}
/**
 * Mirrors the backend's `IsAddressComplete`: a write with any of these four blank comes back 400
 * `InvoiceAddressInvalid`, so callers should drop an incomplete address rather than send it.
 */
export function isAddressComplete(address) {
    var _a, _b, _c;
    return !!((_a = address === null || address === void 0 ? void 0 : address.street) === null || _a === void 0 ? void 0 : _a.trim()) && !!((_b = address.city) === null || _b === void 0 ? void 0 : _b.trim()) && !!((_c = address.postNumber) === null || _c === void 0 ? void 0 : _c.trim());
}
